import { AutoWebViewJs } from "@droid/android";
import { Button } from "@mui/material";
// import { buildScript, printScript1 } from "@scripts/script1";
import axios from "axios";
type LibPathKey = string
function parseUsedLib(s: string) {
    let res: LibPathKey[] = [];
    let reg = /javaLib\[\"(.*)\"\]/g
    let r = s.matchAll(reg);
    for (let a of r) {
        res.push(a[1] as LibPathKey)
    }
    return res;
}
let beforeJavaLibCreateScript = `
let isScriptRunnable = true;
let scriptExitListeners = [];
function addScriptExitListener(f){
    removeScriptExitListener(f);
    scriptExitListeners.push(f);
}
function removeScriptExitListener(f){
    let index = scriptExitListeners.indexOf(f);
    if(index == -1)return;
    scriptExitListeners.splice(index, 1);
}
function onJavaCallTerminate(){
    callScriptExit();
    return true;
}
function callJavaExit(){

}
function jsCallComplete(){
    callScriptExit();
    callJavaExit();
}

function jsCallFailed(){
    callScriptExit();
    callJavaExit();
}
function callScriptExit(){
    isScriptRunnable = false;
    let res = ""
    console.log('before call exit', scriptExitListeners.length);
    scriptExitListeners.forEach((f)=>{f()});
    console.log('after call exit');
    return res;
}
    `
export function TestScript() {

    async function onClick() {
        // printScript1('hello script1')
        // runProjectScriptDemo();
    }
    return (
        <>
            <Button onClick={onClick}>script</Button>
        </>
    )
}
export default TestScript
async function runProjectScriptDemo() {
    
    const res = await axios.get('/scripts/projectScript07.js')
    const scriptString = res.data
    let dependencies: LibPathKey[] = parseUsedLib(scriptString).concat(parseUsedLib(beforeJavaLibCreateScript));

    // const conf = buildScript({
    //     script: scriptString, injects: ["console", "a11yModel"],
    //     optimizationLevel: -1, printScript: false,
    //     scriptId: "demo.project"
    // }, dependencies, beforeJavaLibCreateScript)
    // const s = AutoWebViewJs.confToScript(conf);
    // console.log('ssssssssssss', s)
    // AutoWebViewJs.instance.callScriptRunner(s);
    // console.log('code', code)
}